module.exports = __webpack_public_path__ + "static/img/tax.89c0bed.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/tax.png
// module id = UGhT
// module chunks = 1